import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeroImageComponent } from './hero-image.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule
    ],
    declarations: [HeroImageComponent],
    exports: [
        HeroImageComponent
    ]
})
export class HeroImageModule {
}
